import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../actions/index";
import { getEncryptedIdForBroadcaster } from "../util/broadcast_util";
import { getData, LOGIN } from "../util/storage";
import * as _ from "lodash";
import { getSearchQuery, isEmpty } from "../util/utility";
//image
import {
  subscribeToBroadcastsFireStore,
  unsubscribeToBroadcastsFireStore,
} from "../util/firebase/firestore";

import { Col, Row } from "reactstrap";
import SectionHeader from "./SectionHeader";
import CardComponent from "../components/CardComponent";

class BroadcastList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      broadcaster: props.broadcasterData,
      trendingBroadcastersList: null,
      sort_by: "most_views",
      pageCount: 1,
      currentPage: 1,
      broadcast_list: {},
    };
  }

  componentDidMount() {
    //every time the dashboard is loaded we check if the user api_token and token is available
    //it the api_token and token is available we do hit getUserDetails Webservice
    this.getBroadcastList();
    subscribeToBroadcastsFireStore(this.getBroadcastList);

    let funCall = () => this.getBroadcastList();

    setInterval(function () {
      funCall();
    }, 60000);
  }

  /**
   * @function This method is called when a component is being removed from the DOM
   * so we have to unsubscribe to all events & disconnect from OT Session
   */
  componentWillUnmount() {
    unsubscribeToBroadcastsFireStore();
  }

  nextPage = () => {
    let current =
      this.props.broadcaster_detail_management.trendingBroadcasters &&
      this.props.broadcaster_detail_management.trendingBroadcasters.data
        .current_page;
    let last =
      this.props.broadcaster_detail_management.trendingBroadcasters &&
      this.props.broadcaster_detail_management.trendingBroadcasters.data
        .last_page;
    current <= last && this.getBroadcastList(current + 1);
  };

  prevPage = () => {
    let current =
      this.props.broadcaster_detail_management.trendingBroadcasters &&
      this.props.broadcaster_detail_management.trendingBroadcasters.data
        .current_page;
    let last =
      this.props.broadcaster_detail_management.trendingBroadcasters &&
      this.props.broadcaster_detail_management.trendingBroadcasters.data
        .last_page;
    current > 1 && this.getBroadcastList(current - 1);
  };

  getBroadcastList = (pageCount) => {
    let page = pageCount ? pageCount : 1;
    getData(LOGIN).then((data) => {
      if (!isEmpty(data) && data.api_token) {
        if (getSearchQuery() === "") {
          this.props.getListOfTrendingBroadcasters(
            data.token,
            data.api_token,
            "",
            this.state.sort_by,
            page
          );
        }
      } else {
        //only run this if the searchQuery is blank
        if (getSearchQuery() === "") {
          this.props.getGuestListOfTrendingBroadcastersGuest(
            "",
            "",
            "",
            this.state.sort_by,
            page
          );
        }
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.broadcaster_detail_management &&
      nextProps.broadcaster_detail_management.sortBroadcastBy &&
      this.state.sort_by !==
        nextProps.broadcaster_detail_management.sortBroadcastBy
    ) {
      this.setState({
        sort_by: nextProps.broadcaster_detail_management.sortBroadcastBy,
      });

      getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
          this.props.getListOfTrendingBroadcasters(
            data.token,
            data.api_token,
            getSearchQuery(),
            nextProps.broadcaster_detail_management.sortBroadcastBy
          );
          this.props.resetSortBroadcast();
        } else {
          this.props.getGuestListOfTrendingBroadcastersGuest(
            "",
            "",
            getSearchQuery(),
            nextProps.broadcaster_detail_management.sortBroadcastBy
          );
        }
      });
    }

    getData(LOGIN).then((data) => {
      if (!isEmpty(data)) {
        if (
          nextProps.broadcaster_detail_management.hasOwnProperty(
            "performSearch"
          ) &&
          nextProps.broadcaster_detail_management.performSearch
        ) {
          this.props.sortBroadcastBy("search");
          this.props.getListOfTrendingBroadcasters(
            data.token,
            data.api_token,
            getSearchQuery(),
            ""
          );
          this.props.setSearchForBroadcasterState(false);
        }
      } else {
        if (
          nextProps.broadcaster_detail_management.hasOwnProperty(
            "performSearch"
          ) &&
          nextProps.broadcaster_detail_management.performSearch
        ) {
          this.props.sortBroadcastBy("search");
          this.props.getGuestListOfTrendingBroadcastersGuest(
            "",
            "",
            getSearchQuery(),
            ""
          );
          this.props.setSearchForBroadcasterState(false);
        }
      }
    });

    if (
      nextProps.broadcaster_detail_management &&
      nextProps.broadcaster_detail_management.trendingBroadcasters &&
      nextProps.broadcaster_detail_management.trendingBroadcasters.data
    ) {
      this.setState({
        broadcast_list:
          nextProps.broadcaster_detail_management.trendingBroadcasters.data,
        trendingBroadcastersList:
          nextProps.broadcaster_detail_management.trendingBroadcasters.data
            .data,
      });
    }
  }

  onClickOfBroadcast = (broadcaster_id) => (e) => {
    this.props.history.push(
      `/broadcast/${getEncryptedIdForBroadcaster(broadcaster_id)}`
    );
  };

  getTitle = () => {
    switch (this.state.sort_by) {
      case "most_views":
        return "Trending broadcasts";
      case "popularity":
        return "Popular broadcasts";
      case "most_recent":
        return "Recent broadcasts";
      case "available":
        return "Available broadcasters";
      case "live_now":
        return "Live broadcasts";
      default:
        return "Search results";
    }
  };

  handlePageClick = (selecteddata) => {
    let selected = selecteddata.selected;
    console.log("handlePageClick", selected);
    getData(LOGIN).then((data) => {
      if (!isEmpty(data) && data.api_token) {
        this.props.getListOfTrendingBroadcasters(
          data.token,
          data.api_token,
          getSearchQuery(),
          this.props.broadcaster_detail_management.sortBroadcastBy,
          selected + 1
        );
        this.props.resetSortBroadcast();
      } else {
        this.props.getGuestListOfTrendingBroadcastersGuest(
          "",
          "",
          getSearchQuery(),
          this.props.broadcaster_detail_management.sortBroadcastBy,
          selected + 1
        );
      }
    });
  };

    render() {
        return (
            <main role="main" className="container-fluid">
                <div>
                    <Row className={"broadcast-container-parent"}>
                        {
                            this.state.trendingBroadcastersList &&
                            this.state.trendingBroadcastersList.length !== 0 &&
                            (
                                <Col md="12" className="broadcast-container">
                                    <Col sm="12" className="bg-white p-3 mb-3 rounded">
                                        <SectionHeader
                                            className="sectionheadertitle"
                                            title={this.getTitle()}
                                            next={() => this.nextPage()}
                                            lastPage={
                                                this.props.broadcaster_detail_management
                                                    .trendingBroadcasters &&
                                                this.props.broadcaster_detail_management
                                                    .trendingBroadcasters.data.last_page
                                            }
                                            currentPage={
                                                this.props.broadcaster_detail_management
                                                    .trendingBroadcasters &&
                                                this.props.broadcaster_detail_management
                                                    .trendingBroadcasters.data.current_page
                                            }
                                            previous={() => this.prevPage()}
                                        />
                                    </Col>
                                    <Row>
                                        <Col sm="12">
                                            <Row
                                                className="broadcast-row no-margin no-padding negative-broadcast-list-item">
                                                {this.state.trendingBroadcastersList &&
                                                this.state.trendingBroadcastersList.length > 0 &&
                                                _.map(this.state.trendingBroadcastersList, (data,index) => {
                                                    return (
                                                        <CardComponent
                                                            key={`broadcast-list-${index}`}
                                                            isBadges={true}
                                                            iconSize={2}
                                                            bgColor={"#F7F7F7"}
                                                            broadcastDetail={data}
                                                        />
                                                    );
                                                })}
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            )
                        }
                    </Row>

          <Row className="broadcast-container-parent">
            {this.state.trendingBroadcastersList &&
              this.state.trendingBroadcastersList.length === 0 && (
                <Col md="12" className="broadcast-container">
                  <Col sm="12" className="p-3 mb-3 rounded">
                    <div style={{ textAlign: "center" }}>
                      <img
                        src={
                          "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/no-results-found.svg"
                        }
                        alt={"No results found"}
                        width={"50%"}
                      />
                      <h4 style={{ fontWeight: "bold", marginTop: 20 }}>
                        No results found
                      </h4>
                      <p style={{ margin: "0% 20%" }}>
                        Sorry, there isn’t anyone broadcasting LIVE at the
                        moment. Try using the search bar to find what you are
                        looking for and get connected?
                      </p>
                    </div>
                  </Col>
                </Col>
              )}
          </Row>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state, ownParams) {
  return {
    account_management: state.account_management,
    broadcaster_detail_management: state.broadcaster_detail_management,
  };
}

export default connect(mapStateToProps, actions)(BroadcastList);
